// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
// tslint:disable
import { Component, OnInit, forwardRef, Optional, Host, SkipSelf, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, ControlContainer } from '@angular/forms';

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputTextComponent),
  multi: true
};

export interface InputTextErrorMessages {
  key: string;
  message: string;
}

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  providers: [VALUE_ACCESSOR]
})
export class InputTextComponent implements ControlValueAccessor, OnInit {
  @Input() formControlName = '';
  @Input() label = 'Input Name';
  @Input() type = 'text';
  @Input() errorMessages: InputTextErrorMessages[] = [];

  control: FormControl = new FormControl();
  inputValue: any = '';
  isDisabled = false;

  propagateChange: Function = () => null;

  writeValue(obj: any): void {
    this.inputValue = obj ? obj : '';
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    if (!this.controlContainer.control) {
      return;
    }

    this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
  }

  isInputEmpty() {
    return this.inputValue === '' || this.inputValue === null || this.inputValue === undefined;
  }

  onKeyup(value: string | number) {
    const previousValue = this.inputValue;
    this.inputValue = value;
    if (previousValue !== value) {
      this.propagateChange(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input-text/input-text.component.ts